import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import _isEmpty from 'lodash/isEmpty';
import { Theme } from 'styles/ThemeTyping';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

interface Props {
  nameValue: string;
  descriptionValue: string;
  errors: any;
  isDefaultRole?: boolean;
  setFieldValue: (field: string, value: any) => void;
}

function RoleNameAndDescription({
  nameValue,
  descriptionValue,
  errors,
  isDefaultRole,
  setFieldValue,
}: Props) {
  const classes = useStyles();
  const [userHasTouchedTheForm, setUserHasTouchedTheForm] = useState(false);

  return (
    <Card className={classes.root}>
      <CardContent>
        <div>
          <Typography variant="h5">Role Information</Typography>
          <Typography variant="body2" className={classes.subtitle}>
            Choose the name and description for this role to make it easily identifiable.
          </Typography>

          <div className={classes.nameInput}>
            <Typography id="name" variant="h6">
              Role Name
            </Typography>
            <TextField
              fullWidth
              value={nameValue}
              error={userHasTouchedTheForm && !_isEmpty(errors)}
              onChange={e => {
                if (!userHasTouchedTheForm) {
                  setUserHasTouchedTheForm(true);
                }

                setFieldValue('name', e.target.value);
              }}
              helperText={errors.name && errors.name}
              disabled={isDefaultRole}
              data-cy="role-name-input"
              role="textbox"
              aria-label="Role Name Input"
              inputProps={{ 'aria-labelledby': 'name' }}
            />
          </div>

          <div>
            <Typography variant="h6" id="description">
              Role Description
            </Typography>
            <TextField
              fullWidth
              value={descriptionValue}
              onChange={e => {
                if (!userHasTouchedTheForm) {
                  setUserHasTouchedTheForm(true);
                }

                setFieldValue('description', e.target.value);
              }}
              error={userHasTouchedTheForm && !_isEmpty(errors.description)}
              helperText={errors.description && errors.description}
              disabled={isDefaultRole}
              data-cy="role-description-input"
              role="textbox"
              aria-label="Role Description Input"
              inputProps={{ 'aria-labelledby': 'description' }}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 900,
    marginRight: theme.spacing(3),
    width: '100%',
  },
  subtitle: {
    color: theme.colors.gray2,
  },
  nameInput: {
    marginBottom: 32,
    marginTop: 16,
  },
}));

export default RoleNameAndDescription;
